import { ID } from '@griply/types';

import {
  getLinkedItemColor,
  GetLinkedItemColorOptions,
  isResolvedColor,
} from './get-linked-item-color';

export type FrozenGoalColorSource = {
  id: ID;
  color?: string | null;
};

// The colour to store when a goal's links migrate, or `undefined` to write nothing.
// Resolved against the links the goal has NOW: the frozen value is the colour it shows today,
// not the one its new parent would give it.
export const resolveFrozenGoalColor = (
  goal: FrozenGoalColorSource,
  options: GetLinkedItemColorOptions,
): string | undefined => {
  if (isResolvedColor(goal.color)) {
    return undefined;
  }

  // A null here is transient and self-healing; writing it would make the gap permanent.
  return getLinkedItemColor(goal.id, options) ?? undefined;
};
